import { LazyWalletAssetModal } from '#components'
import { createEventHook, whenever } from '@vueuse/core'

const overlay = useOverlay()
const walletAssetModal = overlay.create(LazyWalletAssetModal)

export function useWalletSidebar() {
  const route = useRoute()

  // Auto-close slide over when navigating to different pages
  watch(
    () => route.path,
    (newPath, oldPath) => {
      if (oldPath && newPath !== oldPath) {
        walletAssetModal.close()
      }
    },
  )

  return {
    walletAssetModal,
  }
}

export default function useWalletManager() {
  const walletStore = useWalletStore()
  const { accountId } = useAuth()
  const { selectedAccounts, getUserConnectedWallets } = storeToRefs(walletStore)
  const accountStore = useAccountStore()
  const disconnectEvent = createEventHook<void>()

  async function disconnectWallet(wallet: WalletExtension) {
    const vm = wallet.vm

    if (vm === 'EVM' && import.meta.client) {
      const { disconnect: disconnectReown } = useReown()

      try {
        await disconnectReown()
      }
      catch (error) {
        console.error('Error disconnecting reown wallet:', error)
      }
    }

    walletStore.updateWallet(wallet.id, {
      accounts: [],
      state: WalletStates.Disconnected,
    })

    if (walletStore.isWalletAccountSelected(wallet)) {
      selectedAccounts.value[vm] = undefined
      accountStore.clearAuth(vm)
    }
  }

  function backToWalletSelection() {
    walletStore.setStage(WalletStageTypes.Wallet)
  }

  async function logoutConnectedWallets() {
    for (const wallet of getUserConnectedWallets.value) {
      await disconnectWallet(wallet)
    }

    backToWalletSelection()
  }

  whenever(
    () => !accountId.value,
    () => disconnectEvent.trigger(),
    { flush: 'sync' },
  )

  return {
    disconnectWallet,
    logoutConnectedWallets,
    onDisconnect: disconnectEvent.on,
    backToWalletSelection,
  }
}
